import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Nav, NavItem, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useBranches } from './useBranches';

const SIN_RAMA_KEY = 'sin-rama';

export const VisitSheetsTabs = ({ protocolId, visits = [], renderVisits, refreshKey }) => {
    const { t } = useTranslation();
    const [branches, isLoading] = useBranches(protocolId, refreshKey);
    const [activeTab, setActiveTab] = useState(SIN_RAMA_KEY);
    const initialized = useRef(false);

    const hasSinRama = useMemo(
        () => visits.some(v => !v.branches || v.branches.length === 0),
        [visits]
    );

    useEffect(() => {
        if (initialized.current || isLoading || branches.length === 0 || visits.length === 0) return;
        if (!hasSinRama) {
            setActiveTab(String(branches[0].id));
        }
        initialized.current = true;
    }, [isLoading, branches, hasSinRama, visits.length]);

    const visitsForTab = useMemo(() => {
        if (activeTab === SIN_RAMA_KEY)
            return visits.filter(v => !v.branches || v.branches.length === 0);
        const branchId = parseInt(activeTab, 10);
        return visits.filter(v => v.branches?.some(b => b.branchId === branchId));
    }, [activeTab, visits]);

    if (isLoading) return null;

    if (!branches.length)
        return <>{renderVisits(visits)}</>;

    return (
        <Tab.Container activeKey={activeTab} onSelect={setActiveTab} id="visit-sheets-tabs">
            <div>
                <Nav bsStyle="tabs">
                    {hasSinRama && (
                        <NavItem eventKey={SIN_RAMA_KEY}>
                            {t('protocols.branches.sinRama')}
                        </NavItem>
                    )}
                    {branches.map(branch => (
                        <NavItem key={branch.id} eventKey={String(branch.id)}>
                            {branch.name}
                        </NavItem>
                    ))}
                </Nav>
                <Tab.Content animation={false}>
                    <Tab.Pane eventKey={activeTab}>
                        {renderVisits(visitsForTab)}
                    </Tab.Pane>
                </Tab.Content>
            </div>
        </Tab.Container>
    );
};
